export const bookingServiceOptions = ["Online", "In-Person", "Both"];

export const regionOptions = [
  "Belfast & Northern Ireland - 1 (BNI 1)",
  "Belfast & Northern Ireland - 2 (BNI 2)",
  "Belfast & Northern Ireland - 3 (BNI 3)",
  "Belfast & Northern Ireland - 4 ((BNI 4))",
  "East England - 1 (EE 1)",
  "East England - 2 (EE 2)",
  "East England - 3 (EE 3)",
  "East England- 4 (EE 4)",
  "East England- 5 ((EE 5))",
  "East Midlands - 1 (EM 1)",
  "East Midlands - 2 (EM 2)",
  "East Midlands - 3 (EM 3)",
  "London & South East - 1 (LSE 1)",
  "London & South East - 2 (LSE 2)",
  "London & South East - 3 (LSE 3)",
  "London & South East - 4 (LSE4)",
  "London & South East - 5 (LSE5)",
  "New Region (NEW)",
  "North West - 1 (NW 1)",
  "North West - 2 (NW 2)",
  "North West - 3 (NW 3)",
  "North West - 4 (NW 4)",
  "Scotland (SCT)",
  "South Wales – 1 (SWL 1)",
  "South West - 1 (SW 1)",
  "South West - 2 (SW 2)",
  "South West - 3 (SW 3)",
  "South West - 4 (SW 4)",
  "West Midlands - 1 (WM 1)",
  "West Midlands - 2 (WM 2)",
  "West Midlands - 3 (WM 3)",
  "West Midlands - 4 (WM 4)",
  "Yorks & Humber - 1 (YH 1)",
  "Yorks & Humber - 2 (YH 2)",
  "Sydney", // Australia
  "Auckland", // New Zealand
];

export const idTypeOptions = [
  "Passport",
  "Driver's License",
  "National Identity Card",
  "Other",
];
